import { render, staticRenderFns } from "./ServiceCodeDialog.vue?vue&type=template&id=443080b4&scoped=true&"
import script from "./ServiceCodeDialog.vue?vue&type=script&lang=js&"
export * from "./ServiceCodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443080b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('443080b4')) {
      api.createRecord('443080b4', component.options)
    } else {
      api.reload('443080b4', component.options)
    }
    module.hot.accept("./ServiceCodeDialog.vue?vue&type=template&id=443080b4&scoped=true&", function () {
      api.rerender('443080b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/ServiceCodeDialog.vue"
export default component.exports